import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'サービス',

  // model
  serviceModel: [],
  serviceTypeModel: [],
  tenantModel: [],
  communityModel: [],

  // 検索
  filters: {
    searchServiceId: null,
    searchServiceName: null,
    searchServiceType: '',
    searchStatus: '',
    searchTenant: '',
    searchCommunity: '',
  }
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceParams}) {
    let serviceTypeParams = {}
    let tenantParams = {
      filters: {
        tenantStatus: 1
      }
    }
    let communityParams = {
      filters: {
        communityStatus: 1
      }
    }
    
    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'service',
          'const',
          'tenant',
          'community'
        ],
        [
          'v1ServiceListGet',
          'v1ServiceTypeListGet',
          'v1TenantListGet',
          'v1CommunityListGet'
        ],
        [
          serviceParams,
          serviceTypeParams,
          tenantParams,
          communityParams
        ])
        .then(res => {
          let status = Utility.parseResponse(res)
          console.log(' =>', status)

          if (status.result) {
            // 正常処理
            commit('setServiceModel', res[0].data.serviceInfo)
            commit('setServiceTypeModel', res[1].data.serviceTypes)
            commit('setTenantModel', res[2].data.tenants)
            commit('setCommunityModel', res[3].data.communities)
            console.log('serviceModel', state.serviceModel)
            console.log('serviceTypeModel', state.serviceTypeModel)
            console.log('tenantModel', state.tenantModel)
            console.log('communityModel', state.communityModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * サービス一覧を読出し
   */
  loadServiceList ({commit}, {serviceParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['service'],
        ['v1ServiceListGet'],
        [serviceParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceModel', res[0].data.serviceInfo)
            console.log('serviceModel', state.serviceModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  reset({commit}) {
    commit('resetState')
  }
}

const mutations = {
  // model
  setServiceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'serviceModel', data)
  },
  setServiceTypeModel (state, data) {
    Vue.set(state, 'serviceTypeModel', data)
  },
  setTenantModel (state, data) {
    Vue.set(state, 'tenantModel', data)
  },
  setCommunityModel (state, data) {
    Vue.set(state, 'communityModel', data)
  },

  setInputFilter (state, {key, value}) {
    Vue.set(state.filters, key, value)
  },

  resetState (state) {
    Vue.set(state, 'serviceModel', [])
    Vue.set(state, 'serviceTypeModel', [])
    Vue.set(state, 'tenantModel', [])
    Vue.set(state, 'communityModel', [])

    state.filters.searchServiceId = null
    state.filters.searchServiceName = null
    state.filters.searchServiceType = ''
    state.filters.searchStatus = ''
    state.filters.searchTenant = ''
    state.filters.searchCommunity = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
